import { render, staticRenderFns } from "./SearchProject.vue?vue&type=template&id=21da6602"
import script from "./SearchProject.vue?vue&type=script&lang=js"
export * from "./SearchProject.vue?vue&type=script&lang=js"
import style0 from "./SearchProject.vue?vue&type=style&index=0&id=21da6602&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports